import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DonutChart = ({ data }) => {
  const [selected, setSelected] = useState(0);
  const [unselected, setUnselected] = useState(0);

  useEffect(() => {
    const totalLocals = Object.keys(data).length;
    const count = Object.values(data).filter(
      (item) => item.selected !== null
    ).length;
    setSelected(count);
    setUnselected(totalLocals - count);
  }, [data]);

  const chartData = {
    labels: null,
    datasets: [
      {
        data: [selected, unselected],
        backgroundColor: ["#00ba00", "#c3c3c3"],
      },
    ],
  };

  return (
    <div
      style={{
        width: "150px",
        height: "150px",
      }}
    >
      <Doughnut data={chartData} />
    </div>
  );
};

export default DonutChart;
